export const PENALIZED_FILTERS_TEST_ID = 'PENALIZED_FILTERS_TEST_ID';
export const PENALIZED_FILTERS_LABEL_TEST_ID =
  'PENALIZED_FILTERS_LABEL_TEST_ID';
